import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import { uploadFileToS3 } from '@/helpers';
import { useApiMutation, useApiQuery, useFetch } from '@/modules/common';

import { StyleItem, StylesUploadUrlData } from '../types';

export function useStyleDetails(styleId: string) {
  const fetchClient = useFetch();

  const getUploadUrlDataMutation = useMutation<
    StylesUploadUrlData & { file: File },
    undefined,
    { file: File }
  >({
    mutationFn: async ({ file }) => {
      const res = await fetchClient(`/styles/reupload-url/${styleId}`, {
        method: 'GET',
      });
      return { ...res, file };
    },
    onSuccess: async ({ styleImageUploadUrl, file }) => {
      await uploadFileToS3({
        file,
        uploadUrl: styleImageUploadUrl,
      });
    },
  });

  const { isFetching, data, refetch } = useApiQuery<StyleItem>(
    `/styles/${styleId}`,
    {
      queryKey: ['styleDetails', styleId],
      initialData: null,
    }
  );

  const updateStyleMutation = useApiMutation<StyleItem>(
    '/styles',
    {
      method: 'PATCH',
    },
    {
      onSuccess: () => {
        refetch();
      },
    }
  );

  return {
    isFetching,
    getUploadUrlDataMutation,
    details: data,
    updateStyleMutation,
  } as const;
}
